<div class="container" *ngIf="cursos$ | async as cursos; else loading">
    <ng-container *ngFor="let curso of cursos">
        <mat-card class="curso-card"  *ngIf="curso.tipo == 'bricolaje'">
            
                <mat-card-title [routerLink]="['/noticia',curso.id]">
                    <img [src]="curso.imagen" alt="">
                    <span>{{curso.titulo}}</span>  
                    <mat-divider></mat-divider>
                </mat-card-title>
            
                <mat-card-content [routerLink]="['/noticia',curso.id]">
                <p>
                    {{curso.content | contenido}}
                </p>
                </mat-card-content>
            
        </mat-card>
    </ng-container>
</div>


<ng-template #loading>
    
    <div id="load">
    
         <div class="container-spinner">
            <mat-spinner color="accent">Cargando...</mat-spinner>
         </div>
         <!-- <img src="../../../assets/spinner.gif" alt="" id="imagenSpin"> -->
     </div>
</ng-template>